import {
  Col,
  DatePicker,
  Divider,
  Dropdown,
  Form,
  Input,
  MenuProps,
  Modal,
  Row,
  Space,
  Tabs,
  TabsProps,
  Tag,
} from 'antd';
import { Content } from 'antd/es/layout/layout';
import {
  Folder,
  Calendar,
  Polygon,
  WhiteEditIcon,
  MoreOption,
  UpdateIcon,
  LinkIcon,
  CategoryCancel,
} from 'assets/svg';
import { MainLayout } from 'components';
import ListAttachFile from 'components/Modules/Product/ListAttachFile';
import Info from 'components/Modules/Category/Info';
import Product from 'components/Modules/Category/Product';
import Branch from 'components/Modules/Category/Branch';
import Cart from 'components/Modules/Category/Cart';
import Order from 'components/Modules/Category/Order';
import { useMutation, useQuery } from 'react-query';
import { useParams } from 'react-router';
import { useEffect, useState } from 'react';
import { IPortfolio } from 'interface/portfolio.interface';
import { STATUS } from 'constants/reponseStatus';
import handleError401 from 'utils/handleError401';
import PortfolioApi from 'apis/PortfolioApi';
import { PRODUCT_POF_STATUS } from 'constants/productStatus';
import { IProduct } from 'interface/product.interface';
import pageTitleStore from 'store/pageTitleStore';
import useQueryParam from 'hooks/useQueryPrams';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import { openNotificationWithIcon } from 'utils/notification';
import { useHistory, useLocation } from 'react-router-dom';
import Button from 'components/Button';
import TextArea from 'antd/es/input/TextArea';
import { HocChangePagination } from 'utils/HocChangePagination';

interface IParams {
  id: string;
}

export default function CategoryInfoPage(): JSX.Element {
  const { id } = useParams<IParams>();
  const portfolioItem = useLocation().state as any;

  const [portfolio, setPortfolio] = useState<IPortfolio>();
  const [checkBtn, setCheckBtn] = useState<boolean>(
    portfolioItem?.status == 0 ? false : true
  );

  const [products, setProducts] = useState<IProduct[]>([]);
  const [total, setProductTotal] = useState<number>(0);
  const [loadingAllProduct, setLoadingAllProduct] = useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  const queryParam = useQueryParam();
  const page = parseInt(queryParam.get('page') + '') || 1;
  const history = useHistory();

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const functionParams = {
    page: page,
    page_size: page_size,
  };

  const params = JSON.parse(JSON.stringify(functionParams));
  const { mutate: getDetail, isLoading: isLoading } = useMutation(
    ['getDetail'],
    () => PortfolioApi.getDetail(id),
    {
      onSuccess: (response) => {
        if (response.status === STATUS.SUCCESS) {
          const { created_at, start_date, end_date, ...rest } = response.data;
          const portfolio: IPortfolio = {
            ...rest,
            created_at: new Date(created_at),
            start_date: new Date(start_date),
            end_date: new Date(end_date),
          };

          setPortfolio(portfolio);
          setBreadcrumb([
            { title: <a href="/category">Danh mục hàng hóa</a> },
            { title: <a href="">{portfolio.pof_name}</a> },
          ]);
          setTitle(`${portfolio.pof_name}`);
        }
      },
      onError: (error: any) => {
        if (error.response.data.status === 401) {
          handleError401();
        }
      },
    }
  );

  const { mutate: getProducts, isLoading: isProductLoading } = useMutation(
    (request: any) => PortfolioApi.getProducts(request.pof_code, params),
    {
      onSuccess: (response: any) => {
        console.log('response');
        if (response.status === STATUS.SUCCESS) {
          setProducts(response.data);
          setProductTotal(response.total);
        }
      },
      onError: (error: any) => {
        if (error.response.data.status === 401) {
          handleError401();
        }
      },
    }
  );

  const { mutate: sendApproveRequest, isLoading: sendApproveRequestLoading } =
    useMutation(
      'sendApproveRequest',
      () => PortfolioApi.requestCategoryApprove(id),
      {
        onSuccess: (response: any) => {
          if (response?.status === 'failure') {
            openNotificationWithIcon(
              'error',
              'Không thể gửi phê duyệt',
              `${response.message}`
            );
          } else {
            setCheckBtn(true);
            openNotificationWithIcon('success', 'Gửi phê duyệt thành công');
            history.push('/category');
          }
        },
        onError: (error: any) => {
          console.log(error);
        },
      }
    );

  useEffect(() => {
    getDetail();
  }, []);

  useEffect(() => {
    if (portfolio) {
      getProducts(portfolio);
    }

    const pageTitle = 'PNJ - PMS';
    document.title = pageTitle;
  }, [page, portfolio, page_size]);

  const handleReloadProducts = () => {
    getProducts(portfolio);
  };

  const handleUpdateProducts = () => {
    setLoadingAllProduct(true);
    PortfolioApi.getProducts(portfolio?.pof_code || '', {
      page: 1,
      page_size: total,
    })
      .then((response) => {
        setLoadingAllProduct(false);
        history.push('/product-update', {
          selectedProducts: response.data,
        });
      })
      .catch((error) => {
        setLoadingAllProduct(false);
        openNotificationWithIcon('error', 'Tải sản phẩm thất bại');
      });
  };

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: `Sản phẩm`,
      children: (
        <Product
          pof_code={portfolio?.pof_code || ''}
          pof_type_code={portfolio?.pof_type_code || ''}
          products={products}
          total={total}
          isLoading={isProductLoading}
          onReloadProducts={handleReloadProducts}
          onUpdateProducts={handleUpdateProducts}
        />
      ),
    },
    // {
    //   key: '2',
    //   label: `Chi nhánh đăng ký mẫu`,
    //   children: <Branch />,
    // },
    // {
    //   key: '3',
    //   label: `Đăng ký giỏ hàng danh mục`,
    //   children: <Cart />,
    // },
    // {
    //   key: '4',
    //   label: `Đơn hàng`,
    //   children: <Order />,
    // },
    // {
    //   key: '5',
    //   label: `Lịch sử phê duyệt`,
    //   children: `Content of Tab Pane 5`,
    // },
    {
      key: '6',
      label: `Thông tin`,
      children: <Info portfolio={portfolio} />,
    },
    // {
    //   key: '6',
    //   label: `Thông tin`,
    //   children: <CategorySampleData />,
    // },
    // {
    //   key: '7',
    //   label: `Tài liệu đính kèm`,
    //   children: <ListAttachFile id={portfolio?.id} />,
    // },
  ];
  const ApproveRequestButton: MenuProps = {
    items: [
      {
        label: 'Phát hành danh mục',
        key: '1',
      },
      {
        label: 'Chi nhánh đăng ký mẫu',
        key: '2',
      },
      {
        label: 'Đăng ký giỏ hàng danh mục',
        key: '3',
      },
    ],
  };

  const menuItems: MenuProps = {
    items: [
      {
        label: 'Chỉnh sửa danh mục',
        key: '4',
        icon: <UpdateIcon />,
        onClick: () => {
          if (portfolio?.status === 0) {
            setIsModalOpen(true);
          } else {
            openNotificationWithIcon(
              'error',
              'Không được chỉnh sửa danh mục này',
              `Trạng thái danh mục: ${convertStatus(portfolio?.status)}`
            );
          }
        },
      },
      {
        label: 'Tài liệu đính kèm',
        key: '5',
        icon: <LinkIcon />,
      },
      {
        label: <div className="text-red-600">Đóng danh mục</div>,
        key: '6',
        icon: <CategoryCancel />,
      },
    ],
  };

  const convertStatus = (status_number: any) => {
    switch (status_number) {
      case 0:
        return 'Mới tạo';
      case 1:
        return 'Chờ phê duyệt';
      case 2:
        return 'Đã phát hành';
      case 3:
        return 'Hết hạn';
      default:
        return '-';
    }
  };

  return (
    <MainLayout
      isLoading={
        isLoading ||
        isProductLoading ||
        loadingAllProduct ||
        sendApproveRequestLoading
      }
    >
      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        justify="end"
        className="mb-1"
      >
        <Col span={12} className="flex justify-end">
          <Space>
            <Button
              disabled={checkBtn}
              bgColor={checkBtn ? 'bg-gray-300' : 'bg-primary-50'}
              color={'text-white'}
              border={'border-white'}
              onClick={() => {
                sendApproveRequest();
              }}
            >
              <WhiteEditIcon />
              Yêu cầu phê duyệt
            </Button>
            {/* <Dropdown.Button
              className="custom-dropdown-button"
              icon={<Polygon />}
              menu={ApproveRequestButton}
              style={{ paddingTop: '0px' }}
            >
              <div style={{ marginTop: '-5px' }}>
                <Button
                  disabled={checkBtn}
                  onClick={() => {
                    sendApproveRequest();
                  }}
                >
                  <span>
                    <WhiteEditIcon />
                  </span>
                  <span>Yêu cầu phê duyệt</span>
                </Button>
              </div>
            </Dropdown.Button> */}
          </Space>
        </Col>
      </Row>

      <Content
        className="main-content mt-4"
        style={{ paddingTop: '15px', paddingBottom: '15px' }}
      >
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col span={22} className="flex items-center">
            {/* <Tag color="#00538F" className="custom-tag">
              <span className="text-base font-bold mt-4">
                {convertStatus(portfolio?.status)}
              </span>
            </Tag> */}
            <p
              style={{
                fontWeight: 'bold',
                fontSize: '20px',
                paddingLeft: '8px',
              }}
            >
              {portfolio?.pof_name}
            </p>
          </Col>
          <Col span={2} className="flex justify-end">
            <Dropdown
              menu={menuItems}
              trigger={['click']}
              placement="bottomRight"
            >
              <a onClick={(e) => e.preventDefault()}>
                <Space>
                  <MoreOption />
                </Space>
              </a>
            </Dropdown>
          </Col>
        </Row>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mt-3">
          <Col className="" span={6}>
            <div className="text-sm font-semibold text-neutral-70 flex items-center gap-1">
              <Folder />
              Mã danh mục
            </div>
            <div className="text-sm font-semibold text-neutral-40 ml-4">
              {portfolio?.pof_code}
            </div>
          </Col>
          <Col className="" span={6}>
            <div className="text-sm font-semibold text-neutral-70 flex items-center gap-1">
              <Folder />
              <div>Loại danh mục</div>
            </div>
            <div className="text-sm font-semibold text-neutral-40 ml-4">
              {
                PRODUCT_POF_STATUS.find(
                  (item) => item.value === portfolio?.pof_type_code
                )?.label
              }
            </div>
          </Col>
          <Col className="" span={6}>
            <div className="text-sm font-semibold text-neutral-70 items-center flex gap-1">
              <Calendar />
              <div>Ngày tạo</div>
            </div>
            <div className="text-sm font-semibold text-neutral-40 ml-4">
              {portfolio?.created_at.toLocaleDateString('en-GB')}
            </div>
          </Col>
          <Col className="" span={6}>
            <div className="text-sm font-semibold text-neutral-70 items-center flex gap-1">
              <Calendar />
              <div>Ngày đóng sổ</div>
            </div>
            <div className="text-sm font-semibold text-neutral-40 ml-4">
              {portfolio?.end_date.toLocaleDateString('en-GB')}
            </div>
          </Col>
        </Row>
      </Content>

      <Content
        className="main-content mt-3"
        style={{ paddingTop: '0px', paddingBottom: '15px' }}
      >
        <Tabs
          defaultActiveKey="1"
          items={items}
          tabBarExtraContent={
            <span
              className="border border-solid boder-primary-50 rounded-lg font-sans text-sm py-1 px-2 leading-5 bg-gray-100 uppercase"
              style={{ color: '#4da6ff' }}
            >
              {portfolio?.status == 0
                ? 'Mới tạo'
                : portfolio?.status == 1
                ? 'Chờ phê duyệt'
                : portfolio?.status == 2
                ? 'Đã phát hành'
                : portfolio?.status == 3
                ? 'Hết hạn'
                : 'Chưa tạo'}
            </span>
          }
        />
      </Content>

      <Modal
        title={
          <span style={{ fontWeight: 'bold', fontSize: '24px' }}>
            Chỉnh sửa danh mục
          </span>
        }
        width="70%"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        <Divider />
        <Row>
          <Col span={4}>Người tạo danh mục: </Col>
          <Col span={8}>{portfolio?.user_created?.fullName}</Col>
          <Col span={4}>Email: </Col>
          <Col span={8}>{portfolio?.user_created?.email}</Col>
        </Row>

        <Row>
          <Col span={4}>Khối phát hành: </Col>
          <Col span={8}>{portfolio?.user_created?.division}</Col>
          <Col span={4}>Chức danh: </Col>
          <Col span={8}>{portfolio?.user_created?.jobTitle}</Col>
        </Row>

        <Divider />

        <Row>
          <Col span={4}>Loại danh mục: </Col>
          <Col span={8}>
            {
              PRODUCT_POF_STATUS.find(
                (item) => item.value === portfolio?.pof_type_code
              )?.label
            }
          </Col>
          <Col span={4}>Nhãn hàng danh mục: </Col>
          <Col span={8}>{'-'}</Col>
        </Row>

        <Divider />

        <Form layout="vertical">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col span={12}>
              <Form.Item label="Tên danh mục phát hành">
                <Input size="small" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Ngày hết hạn">
                <DatePicker />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item label="Mô tả danh mục">
                <TextArea showCount maxLength={500} />
              </Form.Item>
            </Col>
          </Row>
        </Form>

        <Divider />

        <Row justify={'end'} gutter={{ xs: 2, sm: 4, md: 6, lg: 8 }}>
          <Col>
            <Button
              onClick={handleCancel}
              bgColor="bg-gray-50"
              color="text-gray-80"
              border="border-gray-80"
            >
              Huỷ
            </Button>
          </Col>
          <Col>
            <Button>Cập nhật</Button>
          </Col>
        </Row>
      </Modal>
    </MainLayout>
  );
}
